import { h } from './dom.js';

/** Keep secondary forms closed until requested; preserve entered values on close or error. */
export function revealForm(form: HTMLElement, label: string, id: string): { button: HTMLButtonElement; close(): void; open(): void } {
  form.id = id;
  form.hidden = true;
  const button = h('button', { type: 'button', class: 'btn ghost small', 'aria-expanded': 'false', 'aria-controls': id }, [label]);
  const close = () => { form.hidden = true; button.textContent = label; button.setAttribute('aria-expanded', 'false'); };
  const open = () => {
    form.hidden = false; button.textContent = 'Cerrar'; button.setAttribute('aria-expanded', 'true');
    form.querySelector<HTMLElement>('input,textarea,select,button')?.focus();
  };
  button.addEventListener('click', () => { if (form.hidden) open(); else close(); });
  form.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); close(); button.focus(); } });
  return { button, close, open };
}
